import { SEO_BLURB } from './copy';
import { paragraphSpacing } from './seo-srp-copy.styles.css';
import { isSupportedArea } from './seo-srp-copy.types';

interface SeoSrpCopyProps {
    geoIdentifier: string;
}

export function SeoSrpCopy({ geoIdentifier }: SeoSrpCopyProps) {
    if (!isSupportedArea(geoIdentifier)) {
        return null;
    }

    return <p className={paragraphSpacing}>{SEO_BLURB[geoIdentifier]}</p>;
}
